import type * as React from 'react';

import { AnimateLifecycle } from '../Animate';

/**
 * Top-level component to use when using a modal.
 * This modal ensures the mount/unmount of the modal is correctly animated.
 *
 * This component should ALWAYS be in the DOM:
 *
 * <ModalAnimateLifecycle>
 *   {opened ? <Modal ... /> : null}
 * </ModalAnimateLifecycle>
 */
export function ModalAnimateLifecycle(props: {
    children: React.ReactElement | null;
}): React.ReactElement {
    const { children } = props;

    return <AnimateLifecycle>{children}</AnimateLifecycle>;
}
